<script setup lang="ts">
import UiSkeleton from '@/components/ui/UiSkeleton.vue';

interface Props {
  underlay?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  underlay: true
});
</script>

<template>
  <ul class="list-skeleton" :class="{ 'list-skeleton_underlay': props.underlay }">
    <li v-for="i in 3" :key="i" class="list-skeleton__row">
      <div class="list-skeleton__col">
        <UiSkeleton border-radius="50%" width="44px" height="44px" />
      </div>
      <div class="list-skeleton__col">
        <UiSkeleton width="100%" height="22px" />
        <UiSkeleton width="75%" height="16px" />
      </div>
      <div class="list-skeleton__col">
        <UiSkeleton width="75%" height="16px" />
        <UiSkeleton width="100%" height="22px" />
      </div>
    </li>
  </ul>
</template>

<style scoped>
.list-skeleton {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.list-skeleton_underlay {
  padding: 16px;
  background-color: var(--color-main-underlay);
  border-radius: 12px;
}

.list-skeleton__row {
  display: flex;
}

.list-skeleton__row:not(:last-child) {
  margin: 0 0 24px;
}

.list-skeleton__col {
  display: flex;
  flex-direction: column;
}

.list-skeleton__col .ui-skeleton:first-child {
  margin: 0 0 auto;
}

.list-skeleton__col:first-child {
  margin: 0 16px 0 0;
}

.list-skeleton__col:nth-child(2) {
  width: 104px;
  max-width: calc(50% - 40px);
}

.list-skeleton__col:last-child {
  align-items: flex-end;
  width: 90px;
  max-width: calc(50% - 40px);
  margin: 0 0 0 auto;
}
</style>
